import { createSlice } from "@reduxjs/toolkit";
import axios from "../../utils/axios";
const backendUrl = process.env.REACT_APP_BACKEND_URL;
const initialState = {
  isLoading: false,
  error: null,
  kitchenItems: [],
  kitchenDisplayScreens: [], 
  selectedItem: null,
  selectedKds: null,
  ordersCountInSlecetedKds: 0
};

const kitchenSlice = createSlice({
  name: "kitchen",
  initialState,
  reducers: {
    startLoading(state) {
      state.isLoading = true;
    },

    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    getKitchenItemsSuccess(state, action) {
      state.isLoading = false;
      state.kitchenItems = action.payload;
    },

    getKitchenDisplaySuccess(state, action) {
      state.isLoading = false;
      state.kitchenDisplayScreens = action.payload;
      state.selectedKds =  state.selectedKds? state.selectedKds : action.payload[0].name
    },

    changeSelecetdKds(state, action){
      state.selectedKds = action.payload;
    }, 

    changeOrdersCountInSelecetdKds(state, action){
      state.ordersCountInSlecetedKds = action.payload;
    }
  },
});

// Reducer
export default kitchenSlice.reducer;

export const { changeSelecetdKds, changeOrdersCountInSelecetdKds, ordersCountInSlecetedKds } = kitchenSlice.actions;

export function getKitchenItems(data) {
  return async (dispatch) => {
    // dispatch(kitchenSlice.actions.startLoading());
    try {
      const response = await axios.post(
        `${backendUrl}/cart/ordersForPOS`,
        data
      );
      dispatch(
        kitchenSlice.actions.getKitchenItemsSuccess(response.data.results)
      );
    } catch (error) {
      dispatch(kitchenSlice.actions.hasError(error));
    }
  };
}

export function getKitchenDisplayScreens(data) {
  return async (dispatch) => {
    const getToken = sessionStorage.getItem("accessToken");
    dispatch(kitchenSlice.actions.startLoading());
    try {
      const response = await axios.get(
        `${backendUrl}/kds`,  {
          headers: {
            Authorization: `Bearer ${getToken}`,
          },
          params: {
            ...data
          },
        }
    );
      dispatch(
        kitchenSlice.actions.getKitchenDisplaySuccess(response.data.results)
      );
    } catch (error) {
      dispatch(kitchenSlice.actions.hasError(error));
    }
  };
}

export function updateOrdersCountInSelectedKDScreens(venueId, token, user) {
  return async (dispatch, getState) => {
    const currentState = getState().kitchenSlice;
    let allCategoryIds = []
    if(currentState.selectedKds != null){
      const index = currentState.kitchenDisplayScreens?.findIndex(obj => obj.name == currentState.selectedKds);
      if (index != -1) {
        allCategoryIds = currentState.kitchenDisplayScreens[index]?.categories.map(category => category._id)
      }
    } else {
      const response = await axios.get(
        `${backendUrl}/kds`,  {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          params: {
            venueId: venueId,
            venueUsers: user?.id,
            isDeleted: false,
            limit: 1,
          },
        }
      );
      if(response.data.results.length >0){
        for (const categoryId of response.data.results[0].categories){
          allCategoryIds.push(categoryId._id)
        }
        await dispatch(kitchenSlice.actions.getKitchenDisplaySuccess(response.data.results))
      }
    }
    const uniqueCategoryIds = [...new Set(allCategoryIds)];
    try {
      const response = await axios.get(
        `${backendUrl}/cart/countOrdersForKds`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          params: {
            categoriesToPrepare: uniqueCategoryIds,
            venueId: venueId,
            isDeleted: false,
            limit: 999, 
            state: 'processing'
          },
        }
      );
      dispatch(changeOrdersCountInSelecetdKds(response.data.totalResults))
    } catch (error) {
      dispatch(kitchenSlice.actions.hasError(error));
    }
  };
}

// export function updateKitchenItemAvailability(orderId, items, token) {
//   return async (dispatch, getState) => {
//     const currentState = getState().kitchenSlice;
//     try {
//       const response = await axios.post(
//         `${backendUrl}/posCart/updateItemInOrder`,
//         {
//           orderId: orderId,
//           items: items,
//         },
//         {
//           headers: {
//             Authorization: `Bearer ${token}`,
//             "Content-Type": "application/json",
//           },
//         }
//       );
//     } catch (error) {
//       console.error(error);
//       dispatch(kitchenSlice.actions.hasError(error));
//       throw error;
//     }
//   };
// }

export function updateKitchenItemAvailability(
  orderId,
  cartItemId,
  isPrepared,
  token,
  venueUserId
) {
  return async (dispatch, getState) => {
    // dispatch(kitchenSlice.actions.startLoading());
    const currentState = getState().kitchenSlice;
    try {
      const response = await axios.post(
        `${backendUrl}/posCart/updateItemInOrder`,
        {
          orderId: orderId,
          cartItemId: cartItemId,
          item: {
            cartItemId: cartItemId,
            isPrepared: isPrepared,
          },
          venueUserId: venueUserId
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      // const updatedItem = response.data;
      // const updatedState = {
      //   isLoading: false,
      //   kitchenItems: currentState.kitchenItems?.map((item) =>
      //     item.id === updatedItem.id ? updatedItem : item
      //   ),
      // };
      // dispatch(
      //   kitchenSlice.actions.getKitchenItemsSuccess(updatedState?.kitchenItems)
      // );
    } catch (error) {
      console.error(error);
      dispatch(kitchenSlice.actions.hasError(error));
    }
  };
}

export function finalizeKitchenOrder(data) {
  return async (dispatch, getState) => {
    // dispatch(kitchenSlice.actions.startLoading());
    const currentState = getState().kitchenSlice;
    try {
      const response =  await axios.post(`${backendUrl}/cart/changeOrderState`, data);
      const { orderId } = data;
      let updatedKitchenItems;
      if(response.data.state == 'completed' || response.data.state == 'finished'){
        updatedKitchenItems = currentState.kitchenItems.filter(
          (item) => item.id !== orderId 
        );
      }else{
        updatedKitchenItems = currentState.kitchenItems
      }
      dispatch(
        kitchenSlice.actions.getKitchenItemsSuccess(updatedKitchenItems)
      );
    } catch (error) {
      dispatch(kitchenSlice.actions.hasError(error));
    }
  };
}

export function updateKitchenItemsAvailability(
  orderId,
  cartItemIds,
  items,
  token,
  venueUserId
) {
  return async (dispatch, getState) => {
    const currentState = getState().kitchenSlice;
    try {
      const response = await axios.post(
        `${backendUrl}/posCart/updateItemSInOrder`,
        {
          orderId: orderId,
          cartItemIds: cartItemIds,
          items,
          venueUserId: venueUserId
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
    } catch (error) {
      console.error(error);
      dispatch(kitchenSlice.actions.hasError(error));
    }
  };
}
